"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaAliases = exports.MediaLabels = void 0;
var styled_components_1 = require("styled-components");
var MediaLabels;
(function (MediaLabels) {
    MediaLabels["xs"] = "tiny";
    MediaLabels["sm"] = "phone";
    MediaLabels["md"] = "tablet";
    MediaLabels["lg"] = "laptop";
    MediaLabels["xl"] = "desktop";
})(MediaLabels = exports.MediaLabels || (exports.MediaLabels = {}));
var MediaAliases;
(function (MediaAliases) {
    MediaAliases["tiny"] = "xs";
    MediaAliases["phone"] = "sm";
    MediaAliases["tablet"] = "md";
    MediaAliases["laptop"] = "lg";
    MediaAliases["desktop"] = "xl";
})(MediaAliases = exports.MediaAliases || (exports.MediaAliases = {}));
var makeAliases = function (breakpoints) {
    if (breakpoints === void 0) { breakpoints = {}; }
    var data = __assign({}, breakpoints);
    var breakpointsKeys = Object.keys(breakpoints);
    breakpointsKeys.forEach(function (key) {
        var key1 = key;
        var key2 = key;
        if (MediaLabels[key1]) {
            data[MediaLabels[key1]] = breakpoints[key];
        }
        if (MediaAliases[key2] && !data[MediaAliases[key2]]) {
            data[MediaAliases[key2]] = breakpoints[key];
        }
    });
    return data;
};
var defaultBreakpoints = makeAliases({
    xl: 1200,
    lg: 992,
    md: 768,
    sm: 576,
    xs: 0
});
var getBreakpoints = function (props) { return (__assign(__assign({}, defaultBreakpoints), (props.theme || {}))); };
var media = Object.keys(defaultBreakpoints).reduce(function (accumulator, label) {
    var minMedia = function (strings) {
        var interpolations = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            interpolations[_i - 1] = arguments[_i];
        }
        return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (min-width: ", "px) {\n        ", "\n      }\n    "], ["\n      @media (min-width: ", "px) {\n        ", "\n      }\n    "])), function (props) { return getBreakpoints(props)[label]; }, styled_components_1.css.apply(void 0, __spreadArray([strings], __read(interpolations))));
    };
    var maxMedia = function (strings) {
        var interpolations = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            interpolations[_i - 1] = arguments[_i];
        }
        return styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      @media (max-width: ", "px) {\n        ", "\n      }\n    "], ["\n      @media (max-width: ", "px) {\n        ", "\n      }\n    "])), function (props) { return getBreakpoints(props)[label]; }, styled_components_1.css.apply(void 0, __spreadArray([strings], __read(interpolations))));
    };
    accumulator[label] =
        label === "xs" || label === "tiny" ? maxMedia : minMedia;
    accumulator.max[label] = maxMedia;
    accumulator.min[label] = minMedia;
    return accumulator;
}, { min: {}, max: {} });
exports.default = media;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map